import { addressProofDescription, idDocsDescription, yesOrNoOptions } from "../constants.ts";
import { PeriodicReviews } from "../types.ts";

export const getRelationDocRequirements = (
  relationNumber: string,
): PeriodicReviews.WebApp.FormData => {
  return [
    {
      id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_fathers_name`,
      title: {
        en: `Father’s Name`,
        es: `Nombre del Padre`,
        nl: `Naam van de vader`,
        fr: `Le nom du père`,
        pt: `Nome do pai`,
        it: `Nome del padre`,
        de: "Name des Vaters",
        pl: "Imię ojca",
        ro: "Numele tatălui",
        gr: "Όνομα πατρός",
        //TODO: add new language here
      },
      type: "text",
      onlyForCountries: ["Greece"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: ["director"],
      },
    },

    //DOC REQUIREMENTS FOR AUTH CONTACT
    {
      id: `relation_${relationNumber}_relation_type_updated_auth_contact_valid_doc`,
      title: {
        en: `Please provide a valid ID document.`,
        es: `Proporcione un documento de identidad en vigor. `,
        nl: `Geef een geldig identiteitsbewijs op`,
        fr: `Veuillez fournir une pièce d'identité valide`,
        pt: `Providencie um documento de identificação válido`,
        it: `Fornisci un documento di identità valido`,
        de: "Bitte legen Sie einen gültigen Ausweis vor.",
        pl: "Proszę dostarczyć ważny dokument tożsamości.",
        ro: "Vă rugăm să furnizați un document de identitate valabil.",
        gr: "Παρακαλώ προσκομίστε ένα έγκυρο έγγραφο ταυτότητας.",
        //TODO: add new language here
      },
      type: "file",
      description: idDocsDescription,
      onlyForCountries: [
        "Italy",
        "Portugal",
        "Bulgaria",
        "Ireland",
        "Lithuania",
      ],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["auth contact"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_auth_contact_valid_certified_doc`,
      title: {
        en: `Please provide a valid and certified ID document.`,
        es: `Por favor, proporcione una copia certificada del Documento De Identidad. El documento de identidad debe estar en vigor.`,
        nl: `Graag ontvangen wij een geldig en gecertificeerd identiteitsbewijs.`,
        fr: `Veuillez fournir une pièce d'identité valide et certifiée.`,
        pt: `Providencie um documento de identificação válido e autenticado`,
        it: "Si prega di fornire un documento d'identità valido e certificato",
        de: "Bitte legen Sie einen gültigen und beglaubigten Ausweis vor.",
        pl: "Proszę dostarczyć ważny i poświadczony dokument tożsamości.",
        ro: "Vă rugăm să furnizați un document de identitate valabil și certificat.",
        gr: "Παρακαλώ προσκομίστε ένα έγκυρο και πιστοποιημένο έγγραφο ταυτότητας.",
        //TODO: add new language here
      },
      type: "file",
      description: idDocsDescription,
      onlyForCountries: ["Czechia", "Greece", "Poland"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["auth contact"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_auth_contact_electronic_verification_method`,
      title: {
        en: `Would you like to complete the identity verification using an electronic verification method?`,
        es: `¿Preferiría utilizar un método de verificación de identidad electrónica?`,
        nl: `Wilt u liever een elektronische identiteitsverificatiemethode gebruiken?`,
        fr: `Préféreriez-vous utiliser une méthode de vérification d’identité électronique ?`,
        pt: `Deseja completar a verificação de identidade utilizando um método de verificação eletrónica?`,
        it: "Vuoi completare la verifica dell'identità utilizzando un metodo di verifica elettronica?",
        de: "Möchten Sie die Identitätsprüfung mit einer elektronischen Verifizierungsmethode durchführen?",
        pl: "Czy chcesz zakończyć weryfikację tożsamości za pomocą metody weryfikacji elektronicznej?",
        ro: "Doriți să finalizați verificarea identității utilizând o metodă de verificare electronică?",
        gr: "Θα θέλατε να ολοκληρώσετε την επαλήθευση ταυτότητας χρησιμοποιώντας μια ηλεκτρονική μέθοδο επαλήθευσης;",
        //TODO: add new language here
      },
      type: "select",
      options: yesOrNoOptions,
      description: idDocsDescription,
      onlyForCountries: [
        "Canada",
        "Belgium",
        "Czechia",
        "France",
        "Germany",
        "Greece",
        "Italy",
        "Spain",
        "Poland",
        "Netherlands",
        "Luxembourg",
        "Portugal",
        "Bulgaria",
        "Romania",
        "Ireland",
        "Lithuania",
      ],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["auth contact"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_auth_contact_electronic_verification_method_message`,
      type: "paragraph",
      title: {
        en: "Please contact your relationship manager or KYC@ebury.com for them to give you a link to complete the electronic identity verification",
        es: "Póngase en contacto con su gerente de relaciones o kyc@ebury.com para que le den un enlace para completar la verificación de identidad electrónica",
        nl: "Neem contact op met uw relatiebeheerder of KYC@ebury.com zodat zij u een link kunnen geven waarmee u de elektronische identiteitsverificatie kunt voltooien",
        fr: "Veuillez contacter votre responsable relationnel ou KYC@ebury.com pour qu'il vous fournisse un lien permettant de compléter la vérification électronique de l'identité.",
        pt: "Contacte o seu gestor de conta ou KYC@ebury.com para que lhe proporcione um link para a verificação de identifdade eletrónica",
        it: "Contatta il tuo relationship manager o KYC@ebury.com affinché ti forniscano un collegamento per completare la verifica dell'identità elettronica",
        de: "Bitte kontaktieren Sie Ihren Kundenbetreuer oder KYC@ebury.com, damit dieser Ihnen einen Link zur Durchführung der elektronischen Identitätsprüfung zukommen lässt.",
        pl: "Skontaktuj się ze swoim menedżerem ds. relacji lub KYC@ebury.com, aby otrzymać link do ukończenia elektronicznej weryfikacji tożsamości.",
        ro: "Vă rugăm să contactați managerul de relații sau KYC@ebury.com pentru a vă oferi un link pentru a finaliza verificarea electronică a identității.",
        gr: "Παρακαλούμε επικοινωνήστε με τον υπεύθυνο πελατειακών σχέσεων ή το KYC@ebury.com για να σας δώσουν έναν σύνδεσμο για την ολοκλήρωση της ηλεκτρονικής επαλήθευσης ταυτότητας.",
        //TODO: add new language here
      },
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["auth contact"],
        [`relation_${relationNumber}_relation_type_updated_auth_contact_electronic_verification_method`]: [true],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_auth_contact_certified_doc`,
      title: {
        en: `Please upload a certified ID document for each new authorised contact.`,
        es: `Sube un documento de identificación certificado para cada nuevo contacto autorizado.`,
        nl: `Upload voor elk nieuw geautoriseerd contact een gecertificeerd identiteitsbewijs.`,
        fr: `Veuillez télécharger une pièce d'identité certifiée pour chaque nouveau contact autorisé.`,
        pt: `Anexe um documento de identificação certificado para cada novo contacto autorizado.`,
        it: "Carica un documento di identità certificato per ogni nuovo contatto autorizzato.",
        de: "Bitte laden Sie für jeden neuen autorisierten Kontakt ein beglaubigtes Ausweisdokument hoch.",
        pl: "Proszę przesłać poświadczony dokument tożsamości dla każdego nowego autoryzowanego kontaktu.",
        ro: "Vă rugăm să încărcați un document de identitate certificat pentru fiecare nou contact autorizat.",
        gr: "Παρακαλώ ανεβάστε ένα πιστοποιημένο έγγραφο ταυτότητας για κάθε νέα εξουσιοδοτημένη επαφή.",
        //TODO: add new language here
      },
      type: "file",
      description: idDocsDescription,
      onlyForCountries: [
        "Czechia",
        "France",
        "Germany",
        "Italy",
        "Spain",
        "Poland",
        "Netherlands",
        "Luxembourg",
        "Bulgaria",
        "Romania",
      ],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["auth contact"],
        [`relation_${relationNumber}_relation_type_updated_auth_contact_electronic_verification_method`]: [false],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_auth_contact_address_doc`,
      title: {
        en: `Please provide a proof of address document dated within the last 3 months.`,
        es: `Proporcione un documento de prueba de dirección emitido en los últimos 3 meses.`,
        nl: `Gelieve een bewijs van adres op te geven dat gedateerd is binnen de afgelopen 3 maanden.`,
        fr: `Veuillez fournir un justificatif de domicile daté de moins de 3 mois.`,
        pt: `Providencie um comprovativo de endereço com data dos últimos 3 meses.`,
        it: "Fornisci un documento di prova dell'indirizzo datato negli ultimi 3 mesi.",
        de: "Bitte legen Sie einen Adressnachweis vor, der innerhalb der letzten 3 Monate datiert ist.",
        pl: "Proszę dostarczyć dokument potwierdzający adres, datowany w ciągu ostatnich 3 miesięcy.",
        ro: "Vă rugăm să furnizați un document doveditor al adresei, datat în ultimele 3 luni.",
        gr: "Παρακαλώ προσκομίστε ένα έγγραφο απόδειξης διεύθυνσης με ημερομηνία εντός των τελευταίων 3 μηνών.",
        //TODO: add new language here
      },
      type: "file",
      onlyForCountries: [
        "Canada",
        "Germany",
        "Greece",
        "Italy",
        "Netherlands",
        "Luxembourg",
        "Portugal",
        "Bulgaria",
        "Romania",
      ],
      description: addressProofDescription,
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["auth contact"],
      },
    },

    // DOC REQUIREMENTS FOR UBO
    {
      id: `relation_${relationNumber}_relation_type_updated_ubo_sharehold_structure_doc_signed`,
      title: {
        en: `Please provide a document showing the shareholder structure, this must include all intermediary layers in the shareholding structure until reaching the UBO(s) and signed by the legal representative of the company`,
        es: `Por favor, proporcione un documento que refleje la estructura accionarial incluyendo todas las capas intermedias hasta llegar al titular real (UBO) y firmado por el representante legal de la empresa.`,
        nl: `Gelieve een document aan te leveren waaruit de aandeelhoudersstructuur blijkt, dit moet alle tussenliggende lagen in de aandeelhoudersstructuur omvatten tot aan de UBO('s) en ondertekend zijn door de wettelijke vertegenwoordiger van de onderneming.`,
        fr: `Veuillez fournir un document montrant la structure actionnariale, celui-ci doit inclure toutes les couches intermédiaires de la structure actionnariale jusqu'à atteindre le(s) UBO et être signé par le représentant légal de l'entreprise.`,
        pt: `Providencie um documento da estrutura acionista, incluindo todas as empresas intermédias até ao beneficiário efetivo (UBO) e assinado pelo representante legal da empresa.`,
        it: "Si prega di fornire un documento che mostri la struttura azionaria; questo deve includere tutti gli strati intermedi nella struttura della partecipazione azionaria fino al/ai Titolare/i Effettivo/i e firmato dal rappresentante legale dell'azienda.",
        de: "Bitte legen Sie ein Dokument vor, das die Aktionärsstruktur zeigt. Dieses muss alle Zwischenebenen in der Beteiligungsstruktur bis zum Erreichen des/der wirtschaftlich Berechtigten (UBOs) enthalten und vom gesetzlichen Vertreter des Unternehmens unterzeichnet sein.",
        pl: "Proszę dostarczyć dokument przedstawiający strukturę akcjonariatu, który musi zawierać wszystkie warstwy pośrednie w strukturze udziałów aż do osiągnięcia beneficjenta(-ów) rzeczywistego(-ych) (UBO) i podpisany przez prawnego przedstawiciela firmy.",
        ro: "Vă rugăm să furnizați un document care să arate structura acționariatului, acesta trebuie să includă toate straturile intermediare din structura acționariatului până la atingerea beneficiarului (beneficiarilor) reali (UBO) și semnat de reprezentantul legal al companiei.",
        gr: "Παρακαλώ προσκομίστε ένα έγγραφο που να δείχνει τη μετοχική δομή, το οποίο πρέπει να περιλαμβάνει όλα τα ενδιάμεσα επίπεδα στη μετοχική δομή μέχρι να φτάσετε στον/στους πραγματικό(-ούς) δικαιούχο(-ους) (UBO) και υπογεγραμμένο από τον νόμιμο εκπρόσωπο της εταιρείας.",
        //TODO: add new language here
      },
      type: "file",
      onlyForCountries: ["United Arab Emirates", "Belgium", "Czechia", "France", "Germany", "Greece", "Italy", "Spain", "Poland", "Netherlands", "Luxembourg", "Portugal", "Bulgaria", "Romania", "Ireland", "Lithuania", "Chile"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["ubo"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_ubo_sharehold_structure_doc_certified`,
      title: {
        en: `Please provide a document showing the shareholder structure, this must include all intermediary layers in the shareholding structure until reaching the UBO(s) and certified by a verifiable third party`,
        es: `Por favor, proporcione un documento que refleje la estructura accionarial incluyendo todas las capas intermedias hasta llegar al titular real (UBO) y certificado por un tercero verificable.`,
        nl: `Gelieve een document aan te leveren waaruit de aandeelhoudersstructuur blijkt, dit moet alle tussenliggende lagen in de aandeelhoudersstructuur omvatten tot aan de UBO('s) en gecertificeerd zijn door een verifieerbare derde partij.`,
        fr: `Veuillez fournir un document montrant la structure actionnariale, celui-ci doit inclure toutes les couches intermédiaires de la structure actionnariale jusqu'à atteindre le(s) UBO et être certifié par un tiers vérifiable.`,
        pt: `Providencie um documento da estrutura acionista, incluindo todas as empresas intermédias até ao beneficiário efetivo (UBO) e certificado por terceiros verificáveis.`,
        it: "Si prega di fornire un documento che mostri la struttura azionaria; questo deve includere tutti gli strati intermedi nella struttura della partecipazione azionaria fino al/ai Titolare/i Effettivo/i e certificato da una terza parte verificabile.",
        de: "Bitte legen Sie ein Dokument vor, das die Aktionärsstruktur zeigt. Dieses muss alle Zwischenebenen in der Beteiligungsstruktur bis zum Erreichen des/der wirtschaftlich Berechtigten (UBOs) enthalten und von einer nachprüfbaren dritten Partei beglaubigt sein.",
        pl: "Proszę dostarczyć dokument przedstawiający strukturę akcjonariatu, który musi zawierać wszystkie warstwy pośrednie w strukturze udziałów aż do osiągnięcia beneficjenta(-ów) rzeczywistego(-ych) (UBO) i poświadczony przez weryfikowalną stronę trzecią.",
        ro: "Vă rugăm să furnizați un document care să arate structura acționariatului, acesta trebuie să includă toate straturile intermediare din structura acționariatului până la atingerea beneficiarului (beneficiarilor) reali (UBO) și certificat de o terță parte verificabilă.",
        gr: "Παρακαλώ προσκομίστε ένα έγγραφο που να δείχνει τη μετοχική δομή, το οποίο πρέπει να περιλαμβάνει όλα τα ενδιάμεσα επίπεδα στη μετοχική δομή μέχρι να φτάσετε στον/στους πραγματικό(-ούς) δικαιούχο(-ους) (UBO) και πιστοποιημένο από επαληθεύσιμο τρίτο μέρος.",
        //TODO: add new language here
      },
      type: "file",
      onlyForCountries: ["United Kingdom", "Australia", "Canada", "Hong Kong"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["ubo"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_ubo_valid_doc`,
      title: {
        en: `Please provide a valid ID document for all new UBOs.`,
        es: `Por favor, proporcione una copia del Documento De Identidad de todos los nuevos titulares reales.`,
        nl: `Gelieve voor alle nieuwe UBO’s een geldig identiteitsbewijs op te geven.`,
        fr: `Veuillez fournir une pièce d’identité valide pour tous les nouveaux UBO.`,
        pt: `Proporcione um documento de identificação válido para todos os novos UBOs.`,
        it: "Si prega di fornire un documento d'identità valido per tutti i nuovi Titolari Effettivi.",
        de: "Bitte legen Sie für alle neuen wirtschaftlich Berechtigten (UBOs) ein gültiges Ausweisdokument vor.",
        pl: "Proszę dostarczyć ważny dokument tożsamości dla wszystkich nowych beneficjentów rzeczywistych (UBO).",
        ro: "Vă rugăm să furnizați un document de identitate valabil pentru toți noii beneficiari reali (UBO).",
        gr: "Παρακαλώ προσκομίστε ένα έγκυρο έγγραφο ταυτότητας για όλους τους νέους πραγματικούς δικαιούχους (UBO).",
        //TODO: add new language here
      },
      type: "file",
      description: idDocsDescription,
      onlyForCountries: [
        "Belgium",
        "France",
        "Italy",
        "Spain",
        "Portugal",
        "Romania",
      ],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["ubo"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_ubo_valid_certified_doc`,
      title: {
        en: `Please provide a valid and certified ID document for all new UBOs.`,
        es: `Por favor, proporcione una copia certificada del Documento De Identidad de todos los nuevos titulares reales.`,
        nl: `Voor alle nieuwe UBO’s dient u een geldig en gewaarmerkt identiteitsbewijs te verstrekken`,
        fr: `Veuillez fournir une pièce d’identité valide et certifiée pour tous les nouveaux UBO.`,
        pt: `Providencie um documento de identificação válido e certificado para todos os novos UBOs.`,
        it: "Si prega di fornire un documento d'identità valido e certificato per tutti i nuovi Titolari Effettivi.",
        de: "Bitte legen Sie für alle neuen wirtschaftlich Berechtigten (UBOs) ein gültiges und beglaubigtes Ausweisdokument vor.",
        pl: "Proszę dostarczyć ważny i poświadczony dokument tożsamości dla wszystkich nowych beneficjentów rzeczywistych (UBO).",
        ro: "Vă rugăm să furnizați un document de identitate valabil și certificat pentru toți noii beneficiari reali (UBO).",
        gr: "Παρακαλώ προσκομίστε ένα έγκυρο και πιστοποιημένο έγγραφο ταυτότητας για όλους τους νέους πραγματικούς δικαιούχους (UBO).",
        //TODO: add new language here
      },
      type: "file",
      description: {
        en: "Please provide a valid and certified ID document. ID documents should be in date and government issued and contain at least full name, photograph and date of birth. Certifications must be carried out by professionals authorised to do so in your country, be signed and contain the details of the certifier.",
        es: "Por favor, proporcione una copia certificada del Documento De Identidad. El documento de identidad debe estar en vigor e incluir, por lo menos, nombre completo, fotografía y fecha de nacimiento.  Las certificaciones deben llevarse a cabo por profesionales autorizados para ello siguiendo la normativa de su país, y deben estar firmados e incluir los detalles del certificador.",
        nl: "Graag ontvangen wij een geldig en gecertificeerd identiteitsbewijs. Identiteitsdocumenten moeten de datum en de door de overheid afgegeven datum hebben en ten minste de volledige naam, foto en geboortedatum bevatten. Certificeringen moeten worden uitgevoerd door professionals die daartoe in uw land geautoriseerd zijn, de documenten moeten ondertekend zijn en de gegevens van de certificeerder bevatten.",
        fr: "Veuillez fournir une pièce d'identité valide et certifiée. Les documents d'identité doivent être datés et délivrés par le Gouvernement et contenir au moins le nom complet, la photographie et la date de naissance. Les certifications doivent être réalisées par des professionnels habilités à le faire dans votre pays, être signées et contenir les coordonnées du certificateur.",
        pt: "Providencie um documento de identificação válido e certificado. Os documentos de identificação devem estar dentro do prazo de validade, ser emitidos pelo governo e conter pelo menos o nome completo, fotografia e data de nascimento. As certificações devem ser realizadas por profissionais autorizados no seu país, ser assinadas e conter os dados do certificador.",
        it: "Si prega di fornire un documento d'identità valido e certificato. I documenti d'identità devono essere in corso di validità e rilasciati dal governo, e devono contenere almeno nome completo, fotografia e data di nascita. Le certificazioni devono essere eseguite da professionisti autorizzati a farlo nel vostro paese, essere firmate e contenere i dettagli del certificatore.",
        de: "Bitte legen Sie ein gültiges und beglaubigtes Ausweisdokument vor. Ausweisdokumente sollten aktuell und von einer Regierungsbehörde ausgestellt sein und mindestens den vollständigen Namen, ein Foto und das Geburtsdatum enthalten. Beglaubigungen müssen von in Ihrem Land dazu befugten Fachleuten durchgeführt werden, unterzeichnet sein und die Angaben des Beglaubigers enthalten.",
        pl: "Proszę dostarczyć ważny i poświadczony dokument tożsamości. Dokumenty tożsamości powinny być aktualne, wydane przez organ państwowy i zawierać co najmniej imię i nazwisko, zdjęcie oraz datę urodzenia. Poświadczenia muszą być wykonane przez profesjonalistów upoważnionych do tego w Państwa kraju, być podpisane i zawierać dane osoby poświadczającej.",
        ro: "Vă rugăm să furnizați un document de identitate valabil și certificat. Documentele de identitate trebuie să fie la zi, emise de o autoritate guvernamentală și să conțină cel puțin numele complet, fotografia și data nașterii. Certificările trebuie efectuate de profesioniști autorizați în țara dumneavoastră, să fie semnate și să conțină detaliile certificatorului.",
        gr: "Παρακαλείστε να προσκομίσετε ένα έγκυρο και πιστοποιημένο έγγραφο ταυτότητας. Τα έγγραφα ταυτότητας πρέπει να είναι εν ισχύ, εκδοθέντα από κρατική αρχή και να περιέχουν τουλάχιστον ονοματεπώνυμο, φωτογραφία και ημερομηνία γέννησης. Οι πιστοποιήσεις πρέπει να διενεργούνται από επαγγελματίες εξουσιοδοτημένους να το πράττουν στη χώρα σας, να είναι υπογεγραμμένες και να περιέχουν τα στοιχεία του πιστοποιούντος.",
        //TODO: add new language here
      },
      onlyForCountries: ["Luxembourg", "Portugal"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["ubo"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_ubo_electronic_verification_method`,
      title: {
        en: `Would you like to complete the identity verification using an electronic verification method?`,
        es: `¿Le gustaría completar la verificación de identidad utilizando un método de verificación electrónica?`,
        nl: `Wilt u de identiteitsverificatie via een elektronische verificatiemethode voltooien?`,
        fr: `Souhaitez-vous effectuer la vérification d’identité à l’aide d’une méthode de vérification électronique?`,
        pt: `Deseja completar a verificação de identidade utilizando um método de verificação eletrónica?`,
        it: "Vuoi completare la verifica dell'identità utilizzando un metodo di verifica elettronica?",
        de: "Möchten Sie die Identitätsprüfung mit einer elektronischen Verifizierungsmethode durchführen?",
        pl: "Czy chcesz zakończyć weryfikację tożsamości za pomocą metody weryfikacji elektronicznej?",
        ro: "Doriți să finalizați verificarea identității utilizând o metodă de verificare electronică?",
        gr: "Θα θέλατε να ολοκληρώσετε την επαλήθευση ταυτότητας χρησιμοποιώντας μια ηλεκτρονική μέθοδο επαλήθευσης;",
        //TODO: add new language here
      },
      type: "select",
      options: yesOrNoOptions,
      onlyForCountries: [
        "Switzerland",
        "Australia",
        "Hong Kong",
        "United Arab Emirates",
        "Bulgaria",
        "Greece",
        "Netherlands",
        "Romania",
        "Ireland",
      ],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["ubo"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_ubo_electronic_verification_method_message`,
      type: "paragraph",
      title: {
        en: "Please contact your relationship manager or KYC@ebury.com for them to give you a link to complete the electronic identity verification",
        es: "Póngase en contacto con su gerente de relaciones o kyc@ebury.com para que le den un enlace para completar la verificación de identidad electrónica",
        nl: "Neem contact op met uw relatiebeheerder of KYC@ebury.com zodat zij u een link kunnen geven waarmee u de elektronische identiteitsverificatie kunt voltooien",
        fr: "Veuillez contacter votre responsable relationnel ou KYC@ebury.com pour qu'il vous fournisse un lien permettant de compléter la vérification électronique de l'identité.",
        pt: "Contacte o seu gestor de conta ou KYC@ebury.com para que lhe proporcione um link para a verificação de identifdade eletrónica",
        it: "Contatta il tuo relationship manager o KYC@ebury.com affinché ti forniscano un collegamento per completare la verifica dell'identità elettronica",
        de: "Bitte kontaktieren Sie Ihren Kundenbetreuer oder KYC@ebury.com, damit dieser Ihnen einen Link zur Durchführung der elektronischen Identitätsprüfung zukommen lässt.",
        pl: "Skontaktuj się ze swoim menedżerem ds. relacji lub KYC@ebury.com, aby otrzymać link do ukończenia elektronicznej weryfikacji tożsamości.",
        ro: "Vă rugăm să contactați managerul de relații sau KYC@ebury.com pentru a vă oferi un link pentru a finaliza verificarea electronică a identității.",
        gr: "Παρακαλούμε επικοινωνήστε με τον υπεύθυνο πελατειακών σχέσεων ή το KYC@ebury.com για να σας δώσουν έναν σύνδεσμο για την ολοκλήρωση της ηλεκτρονικής επαλήθευσης ταυτότητας.",
        //TODO: add new language here
      },
      onlyForCountries: [
        "Switzerland",
        "Australia",
        "Canada",
        "Hong Kong",
        "United Arab Emirates",
        "Germany",
        "Bulgaria",
      ],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["ubo"],
        [`relation_${relationNumber}_relation_type_updated_ubo_electronic_verification_method`]: [true],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_ubo_certified_doc`,
      title: {
        en: `Please upload a certified ID document.`,
        es: `Por favor, proporcione suba una copia certificada del Documento de Identidad.`,
        nl: `Upload een gecertificeerd identiteitsbewijs.`,
        fr: `Veuillez télécharger une pièce d'identité certifiée.`,
        pt: `Anexe um documento de identificação certificado.`,
        it: "Si prega di caricare un documento d'identità certificato.",
        de: "Bitte laden Sie ein beglaubigtes Ausweisdokument hoch.",
        pl: "Proszę przesłać poświadczony dokument tożsamości.",
        ro: "Vă rugăm să încărcați un document de identitate certificat.",
        gr: "Παρακαλώ ανεβάστε ένα πιστοποιημένο έγγραφο ταυτότητας.",
        //TODO: add new language here
      },
      type: "file",
      onlyForCountries: [
        "Switzerland",
        "Australia",
        "Hong Kong",
        "United Arab Emirates",
        "Bulgaria",
        "Greece",
        "Netherlands",
        "Romania",
        "Ireland",
      ],
      description: idDocsDescription,
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["ubo"],
        [`relation_${relationNumber}_relation_type_updated_ubo_electronic_verification_method`]: [false],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_ubo_address_doc`,
      title: {
        en: `Please provide a proof of address document dated within the last 3 month for all new UBOs.`,
        es: `Por favor, proporcione un justificante de domicilio emitido en los últimos 3 meses para todos los nuevos titulares reales (UBOs).`,
        nl: `UVoor alle nieuwe UBO's verzoeken wij u een adresbewijs mee te sturen dat gedateerd is binnen de afgelopen 3 maanden.`,
        fr: `Veuillez fournir un justificatif de domicile daté de moins de 3 mois pour tous les nouveaux UBO.`,
        pt: `Providencie um comprovativo de endereço com data dos últimos 3 meses para todos os novos UBOs`,
        it: "Si prega di fornire un documento di prova dell'indirizzo datato negli ultimi 3 mesi per tutti i nuovi Titolari Effettivi.",
        de: "Bitte legen Sie für alle neuen wirtschaftlich Berechtigten (UBOs) einen Adressnachweis vor, der innerhalb der letzten 3 Monate datiert ist.",
        pl: "Proszę dostarczyć dokument potwierdzający adres, datowany w ciągu ostatnich 3 miesięcy, dla wszystkich nowych beneficjentów rzeczywistych (UBO).",
        ro: "Vă rugăm să furnizați un document doveditor al adresei, datat în ultimele 3 luni, pentru toți noii beneficiari reali (UBO).",
        gr: "Παρακαλώ προσκομίστε ένα έγγραφο απόδειξης διεύθυνσης με ημερομηνία εντός των τελευταίων 3 μηνών για όλους τους νέους πραγματικούους δικαιούχους (UBO).",
        //TODO: add new language here
      },
      type: "file",
      onlyForCountries: ["Australia", "Greece"],
      description: addressProofDescription,
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["ubo"],
      },
    },

    //DOC REQUIREMENTS FOR DIRECTORS
    {
      id: `relation_${relationNumber}_relation_type_updated_directors_doc`,
      title: {
        en: `Please provide an official/third party document showing the current directors of the company`,
        es: `Por favor, proporcione un documento oficial o de terceros que muestre los directores actuales de la empresa.`,
        nl: `Gelieve een officieel document/document van derden te verstrekken waaruit de huidige bestuurders van de vennootschap blijken.`,
        fr: `Veuillez fournir un document officiel/de tiers indiquant les administrateurs actuels de la société.`,
        pt: `Providencie um documento oficial que indique os atuais diretores da empresa.`,
        it: "Si prega di fornire un documento ufficiale/di terze parti che mostri gli attuali amministratori dell'azienda.",
        de: "Bitte legen Sie ein offizielles/Drittanbieter-Dokument vor, das die aktuellen Geschäftsführer des Unternehmens zeigt.",
        pl: "Proszę dostarczyć oficjalny dokument/dokument od strony trzeciej, przedstawiający obecnych dyrektorów firmy.",
        ro: "Vă rugăm să furnizați un document oficial/de la terți care să arate directorii actuali ai companiei.",
        gr: "Παρακαλώ προσκομίστε ένα επίσημο έγγραφο/έγγραφο τρίτου μέρους που να δείχνει τους τρέχοντες διευθυντές της εταιρείας.",
        //TODO: add new language here
      },
      type: "file",
      onlyForCountries: ["United Arab Emirates"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["director"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_director_electronic_verification_method`,
      title: {
        en: `Would you like to complete the identity verification using an electronic verification method?`,
        es: `¿Le gustaría completar la verificación de identidad utilizando un método de verificación electrónica?`,
        nl: `Wilt u de identiteitsverificatie via een elektronische verificatiemethode voltooien?`,
        fr: `Souhaitez-vous effectuer la vérification d’identité à l’aide d’une méthode de vérification électronique?`,
        pt: `Deseja completar a verificação de identidade utilizando um método de verificação eletrónica?`,
        it: "Vuoi completare la verifica dell'identità utilizzando un metodo di verifica elettronica?",
        de: "Möchten Sie die Identitätsprüfung mit einer elektronischen Verifizierungsmethode durchführen?",
        pl: "Czy chcesz zakończyć weryfikację tożsamości za pomocą metody weryfikacji elektronicznej?",
        ro: "Doriți să finalizați verificarea identității utilizând o metodă de verificare electronică?",
        gr: "Θα θέλατε να ολοκληρώσετε την επαλήθευση ταυτότητας χρησιμοποιώντας μια ηλεκτρονική μέθοδο επαλήθευσης;",
        //TODO: add new language here
      },
      type: "select",
      options: yesOrNoOptions,
      onlyForCountries: ["United Kingdom", "Hong Kong"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["director"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_director_electronic_verification_method_message`,
      type: "paragraph",
      title: {
        en: "Please contact your relationship manager or KYC@ebury.com for them to give you a link to complete the electronic identity verification",
        es: "Póngase en contacto con su gerente de relaciones o kyc@ebury.com para que le den un enlace para completar la verificación de identidad electrónica",
        nl: "Neem contact op met uw relatiebeheerder of KYC@ebury.com zodat zij u een link kunnen geven waarmee u de elektronische identiteitsverificatie kunt voltooien",
        fr: "Veuillez contacter votre responsable relationnel ou KYC@ebury.com pour qu'il vous fournisse un lien permettant de compléter la vérification électronique de l'identité.",
        pt: "Contacte o seu gestor de conta ou KYC@ebury.com para que lhe proporcione um link para a verificação de identifdade eletrónica",
        it: "Contatta il tuo relationship manager o KYC@ebury.com affinché ti forniscano un collegamento per completare la verifica dell'identità elettronica",
        de: "Bitte kontaktieren Sie Ihren Kundenbetreuer oder KYC@ebury.com, damit dieser Ihnen einen Link zur Durchführung der elektronischen Identitätsprüfung zukommen lässt.",
        pl: "Skontaktuj się ze swoim menedżerem ds. relacji lub KYC@ebury.com, aby otrzymać link do ukończenia elektronicznej weryfikacji tożsamości.",
        ro: "Vă rugăm să contactați managerul de relații sau KYC@ebury.com pentru a vă oferi un link pentru a finaliza verificarea electronică a identității.",
        gr: "Παρακαλούμε επικοινωνήστε με τον υπεύθυνο πελατειακών σχέσεων ή το KYC@ebury.com για να σας δώσουν έναν σύνδεσμο για την ολοκλήρωση της ηλεκτρονικής επαλήθευσης ταυτότητας.",
        //TODO: add new language here
      },
      onlyForCountries: ["Hong Kong"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["director"],
        [`relation_${relationNumber}_relation_type_updated_director_electronic_verification_method`]: [true],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_director_certified_doc`,
      title: {
        en: `Please upload a certified ID document.`,
        es: `Por favor, proporcione suba una copia certificada del Documento de Identidad.`,
        nl: `Upload een gecertificeerd identiteitsbewijs.`,
        fr: `Veuillez télécharger une pièce d'identité certifiée.`,
        pt: `Anexe um documento de identificação certificado.`,
        it: "Carica un documento di identità certificato per ogni nuovo contatto autorizzato.",
        de: "Bitte laden Sie ein beglaubigtes Ausweisdokument hoch.",
        pl: "Proszę przesłać poświadczony dokument tożsamości.",
        ro: "Vă rugăm să încărcați un document de identitate certificat.",
        gr: "Παρακαλώ ανεβάστε ένα πιστοποιημένο έγγραφο ταυτότητας.",
        //TODO: add new language here
      },
      type: "file",
      description: idDocsDescription,
      onlyForCountries: ["Hong Kong"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["director"],
        [`relation_${relationNumber}_relation_type_updated_director_electronic_verification_method`]: [false],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_director_address_doc`,
      title: {
        en: `Please provide a proof of address document.`,
        es: `Proporcione un documento de prueba de dirección.`,
        nl: `Gelieve een bewijs van adres op te geven.`,
        fr: `Veuillez fournir un justificatif de domicile.`,
        pt: `Providencie um comprovativo de endereço.`,
        it: "Fornisci un documento di prova dell'indirizzo.",
        de: "Bitte legen Sie einen Adressnachweis vor.",
        pl: "Proszę dostarczyć dokument potwierdzający adres.",
        ro: "Vă rugăm să furnizați un document doveditor al adresei.",
        gr: "Παρακαλώ προσκομίστε ένα έγγραφο απόδειξης διεύθυνσης.",
        //TODO: add new language here
      },
      type: "file",
      description: addressProofDescription,
      onlyForCountries: ["United Kingdom", "United Arab Emirates"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["director"],
      },
    },
    //DOC REQUIREMENTS FOR CORPORATE DIRECTOR DIRECTORS
    {
      id: `relation_${relationNumber}_relation_type_updated_corporate_director_directors_doc`,
      title: {
        en: `Please provide a proof of address document dated within the last 3 month for all new UBOs.`,
        es: `Por favor, proporcione un justificante de domicilio emitido en los últimos 3 meses para todos los nuevos titulares reales (UBOs).`,
        nl: `Voor alle nieuwe UBO's verzoeken wij u een adresbewijs mee te sturen dat gedateerd is binnen de afgelopen 3 maanden.`,
        fr: `Veuillez fournir un justificatif de domicile daté de moins de 3 mois pour tous les nouveaux UBO.`,
        pt: `Providencie um comprovativo de endereço com data dos últimos 3 meses para todos os novos UBOs.`,
        it: "Si prega di fornire un documento di prova dell'indirizzo datato negli ultimi 3 mesi per tutti i nuovi Titolari Effettivi.",
        de: "Bitte reichen Sie für alle neuen wirtschaftlich Berechtigten (UBOs) einen Adressnachweis ein, der innerhalb der letzten 3 Monate ausgestellt wurde.",
        pl: "Prosimy o dostarczenie dokumentu potwierdzającego adres zamieszkania wystawionego w ciągu ostatnich 3 miesięcy dla wszystkich nowych UBO.",
        ro: "Vă rugăm să furnizați un document de dovadă a adresei emis în ultimele 3 luni pentru toți noii UBO.",
        gr: "Παρακαλούμε να προσκομίσετε αποδεικτικό διεύθυνσης που να έχει εκδοθεί τους τελευταίους 3 μήνες για όλους τους νέους UBO.",
        //TODO: add new language here
      },
      type: "file",
      onlyForCountries: ["United Arab Emirates"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: ["director"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_electronic_verification_method`,
      title: {
        en: `Would you like to complete the identity verification using an electronic verification method?`,
        es: `¿Preferiría utilizar un método de verificación de identidad electrónica?`,
        nl: `Wilt u liever een elektronische identiteitsverificatiemethode gebruiken?`,
        fr: `Préféreriez-vous utiliser une méthode de vérification d’identité électronique ?`,
        pt: `Deseja completar a verificação de identidade utilizando um método de verificação eletrónica?`,
        it: "Vuoi completare la verifica dell'identità utilizzando un metodo di verifica elettronica?",
        de: "Möchten Sie die Identitätsprüfung mit einer elektronischen Verifizierungsmethode durchführen?",
        pl: "Czy chcesz zakończyć weryfikację tożsamości za pomocą metody weryfikacji elektronicznej?",
        ro: "Doriți să finalizați verificarea identității utilizând o metodă de verificare electronică?",
        gr: "Θα θέλατε να ολοκληρώσετε την επαλήθευση ταυτότητας χρησιμοποιώντας μια ηλεκτρονική μέθοδο επαλήθευσης;",
        //TODO: add new language here
      },
      type: "select",
      options: yesOrNoOptions,
      onlyForCountries: ["Hong Kong"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: ["director"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_electronic_verification_method_message`,
      type: "paragraph",
      title: {
        en: "Please contact your relationship manager or KYC@ebury.com for them to give you a link to complete the electronic identity verification",
        es: "Póngase en contacto con su gerente de relaciones o kyc@ebury.com para que le den un enlace para completar la verificación de identidad electrónica",
        nl: "Neem contact op met uw relatiebeheerder of KYC@ebury.com zodat zij u een link kunnen geven waarmee u de elektronische identiteitsverificatie kunt voltooien",
        fr: "Veuillez contacter votre responsable relationnel ou KYC@ebury.com pour qu'il vous fournisse un lien permettant de compléter la vérification électronique de l'identité.",
        pt: "Contacte o seu gestor de conta ou KYC@ebury.com para que lhe proporcione um link para a verificação de identifdade eletrónica",
        it: "Contatta il tuo relationship manager o KYC@ebury.com affinché ti forniscano un collegamento per completare la verifica dell'identità elettronica",
        de: "Bitte kontaktieren Sie Ihren Kundenbetreuer oder KYC@ebury.com, damit dieser Ihnen einen Link zur Durchführung der elektronischen Identitätsprüfung zukommen lässt.",
        pl: "Skontaktuj się ze swoim menedżerem ds. relacji lub KYC@ebury.com, aby otrzymać link do ukończenia elektronicznej weryfikacji tożsamości.",
        ro: "Vă rugăm să contactați managerul de relații sau KYC@ebury.com pentru a vă oferi un link pentru a finaliza verificarea electronică a identității.",
        gr: "Παρακαλούμε επικοινωνήστε με τον υπεύθυνο πελατειακών σχέσεων ή το KYC@ebury.com για να σας δώσουν έναν σύνδεσμο για την ολοκλήρωση της ηλεκτρονικής επαλήθευσης ταυτότητας.",
        //TODO: add new language here
      },
      onlyForCountries: ["Hong Kong"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated`]: ["director"],
        [`relation_${relationNumber}_relation_type_updated_corporate_director_director_electronic_verification_method`]: [true],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_certified_doc`,
      title: {
        en: `Please upload a certified ID document.`,
        es: `Por favor, proporcione suba una copia certificada del Documento de Identidad.`,
        nl: `Upload een gecertificeerd identiteitsbewijs.`,
        fr: `Veuillez télécharger une pièce d'identité certifiée.`,
        pt: `Anexe um documento de identificação certificado.`,
        it: "Si prega di caricare un documento d'identità certificato.",
        de: "Bitte laden Sie ein beglaubigtes Ausweisdokument hoch.",
        pl: "Proszę przesłać poświadczony dokument tożsamości.",
        ro: "Vă rugăm să încărcați un document de identitate certificat.",
        gr: "Παρακαλώ ανεβάστε ένα πιστοποιημένο έγγραφο ταυτότητας.",
        //TODO: add new language here
      },
      type: "file",
      description: idDocsDescription,
      onlyForCountries: ["Hong Kong"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: ["director"],
        [`relation_${relationNumber}_relation_type_updated_corporate_director_director_electronic_verification_method`]: [false],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_address_doc`,
      title: {
        en: `Please provide a proof of address document.`,
        es: `Proporcione un documento de prueba de dirección.`,
        nl: `Gelieve een bewijs van adres op te geven.`,
        fr: `Veuillez fournir un justificatif de domicile.`,
        pt: `Providencie um comprovativo de endereço.`,
        it: "Fornisci un documento di prova dell'indirizzo.",
        de: "Bitte legen Sie einen Adressnachweis vor.",
        pl: "Proszę dostarczyć dokument potwierdzający adres.",
        ro: "Vă rugăm să furnizați un document doveditor al adresei.",
        gr: "Παρακαλώ προσκομίστε ένα έγγραφο απόδειξης διεύθυνσης.",
        //TODO: add new language here
      },
      type: "file",
      description: addressProofDescription,
      onlyForCountries: ["United Kingdom", "United Arab Emirates"],
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: ["director"],
      },
    },
    {
      id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_doc`,
      title: {
        en: `Please provide a document showing the full corporate director structure.`,
        es: `Proporcione un documento que muestre la estructura completa del director corporativo.`,
        nl: `Geef een document met de volledige bestuursstructuur.`,
        fr: `Veuillez fournir un document montrant la structure complète du directeur corporatif.`,
        pt: `Providencie um documento que mostre a estrutura completa dos directores da empresa.`,
        it: "Fornisci un documento che mostri la struttura completa del direttore aziendale.",
        de: "Bitte legen Sie ein Dokument vor, das die vollständige Struktur des Unternehmensleiters zeigt.",
        pl: "Proszę dostarczyć dokument przedstawiający pełną strukturę dyrektora korporacyjnego.",
        ro: "Vă rugăm să furnizați un document care să arate structura completă a directorului corporativ.",
        gr: "Παρακαλώ προσκομίστε ένα έγγραφο που να δείχνει την πλήρη δομή του εταιρικού διευθυντή.",
        //TODO: add new language here
      },
      type: "file",
      renderConditions: {
        [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: ["corporate director"],
      },
    },
  ];
};
